export default function _of(x) {
  return [x];
}


// WEBPACK FOOTER //
// /app/apps/ms/node_modules/ramda/es/internal/_of.js